import { Injectable, Injector } from '@angular/core';

import { Bedrijf } from '../dto/bedrijf';
import { CrudService } from '@mango/core';
import { map } from 'rxjs/operators';
import { Printer } from '../dto/printer';

@Injectable({ providedIn: 'root' })
export class BedrijfService extends CrudService<Bedrijf> {

    constructor(injector: Injector) { super(Bedrijf, injector); }

    SelectPrinters() {
        let query: string = `api/dto/projectregel/getprinters`;

        return this.http.post(query, null).pipe(map(x => x as PrinterResponse));

    }
}

export class PrinterResponse {
    printers: string[];    
}
